import React, { Component } from 'react';
import { Link } from 'react-router';
import { getAuthCredentials } from 'common/util/auth-storage';
import { openPopup } from 'common/util/popup';
import { listenForCredentials } from 'common/actions/login';
import Popover from 'components/common/Popover/Popover';
import styles from './AccountMenu.scss';

export default class AccountMenu extends Component {
    constructor(props) {
        super(props);
        this.initiateChangePassword = this.initiateChangePassword.bind(this);
    }

    initiateChangePassword() {
        const accessToken = getAuthCredentials().accessToken;
        const changePasswordUrl = `${this.props.originUrl}/changePassword?access_token=${accessToken}`;
        const popup = openPopup(changePasswordUrl, 'changePassword');
        listenForCredentials(popup);
    }

    render() {
        const {
            me : {firstName, lastName, email, name},
            isSso,
            toggleModal
        } = this.props;

        return (
            <Popover
                data-cy="AccountMenu"
                openDirection={'right'}
                target={
                    <PopoverLabelClosed
                        firstName={firstName}
                        lastInitial={lastName.charAt(0)}
                    />
                } >

                <PopoverLabelOpen
                    firstName={firstName}
                    lastInitial={lastName.charAt(0)}
                />

                <About
                    displayName={name}
                    email={email}
                />

                <ChangePassword
                    isSso={isSso}
                    toggleModal={toggleModal}
                />
                <LogOut />
            </Popover >
        );
    }
}

const PopoverLabelClosed = ({ firstName, lastInitial }) => {
    return (
        < div className={styles.target} data-cy="AccountMenu-PopoverLabelClosed">
            <p className={styles.accountMenu__targetName}>{firstName} <span>{lastInitial}</span>.</p>
            <i className={styles.accountMenu__targetIcon}>account_circle</i>
            <i className={styles.accountMenu__targetIconArrow}>keyboard_arrow_down</i>
        </div >
    );
};

const PopoverLabelOpen = ({ firstName, lastInitial }) => {
    return (
        <div className={styles.accountMenu__sudoTarget} data-cy="AccountMenu-PopoverLabelOpen">
            <p className={styles.accountMenu__sudoTargetName}>{firstName} <span>{lastInitial}</span>.</p>
            <i className={styles.accountMenu__sudoTargetIcon}>account_circle</i>
        </div>
    );
};

const About = ({ displayName, email }) => {
    return (
        <div className={styles.accountMenu__about} data-cy="AccountMenu-About">
            <div className={styles.accountMenu__aboutName}>
                <i className={styles.part11Checkmark}>check_circle</i>
                <p className={styles.accountMenu__aboutNameLabel}>{displayName}</p>
            </div>
            <p className={styles.accountMenu__aboutEmailLabel}>{email}</p>
        </div>
    );
};

const ChangePassword = ({ isSso, toggleModal }) => {
    if (!isSso) {
        return (
            <div className={styles.accountMenu__changePassword} onClick={toggleModal} data-cy="AccountMenu-ChangePassword">
                <i className={styles.part11Checkmark}>check_circle</i>
                <p className={styles.accountMenu__changePasswordLabel}>Change Password</p>
                <i className={styles.accountMenu__changePasswordIcon}>lock</i>
            </div>
        );
    }

    return null;
};

const LogOut = () => {
    return (
        <Link to="/logout" className={styles.accountMenu__logOut} data-cy="AccountMenu-LogOut">
            <i className={styles.part11Checkmark}>check_circle</i>
            <p className={styles.accountMenu__logOutLabel}>Log Out</p>
            <i className={styles.accountMenu__logOutIcon}>exit_to_app</i>
        </Link>
    );
};